import React from 'react'
import Field from '../Common/Field'
import MaskedInput from 'react-text-mask'

function pipe(conformedValue) {
  const indexesOfPipedChars = []
  const conformedValueArr = conformedValue.split('')

  const prefix = '3528 '
  if (!conformedValue.length) {
    return conformedValue
  } else if (conformedValue.length === 1 && conformedValue[0] !== prefix[0]) {
    conformedValueArr[prefix.length] = conformedValueArr[0]
    prefix.split('').forEach((char, i) => {
      conformedValueArr[i] = char
      indexesOfPipedChars.push(i)
    })
  }

  return {
    value: conformedValueArr.join(''),
    indexesOfPipedChars
  }
}

export default class OVChipkaart extends Field {
  constructor() {
    super()
    this.inputRef = React.createRef()
  }

  renderInput() {
    const {
      formikForm, isRequired,
      formikField: { value },
      config: { label, name, placeholder, readOnly, disabled,  }
    } = this.props
    const mask = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]

    return (
      <React.Fragment>
        <input type="hidden" name={name} value={value} />
        <MaskedInput
          id={name}
          type="tel"
          className="field__input field__input--text"
          aria-label={label}
          aria-required={!!isRequired}
          value={value}
          readOnly={!!readOnly}
          disabled={!!disabled}
          placeholder={placeholder}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={(e) => {
            let newValue = e.currentTarget.value.replace(/ /g, '')
            // Handle backspace on space character
            if (mask.length !== e.currentTarget.value.length) {
              if (value.length === newValue.length) {
                newValue = newValue.substr(0, newValue.length - 1)
              }
            }

            formikForm.setFieldValue(name, newValue)
          }}
          guide={false}
          mask={mask}
          pipe={pipe}
        />
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/OVChipkaart.js